import $axios from '../backend/vue-axios/axios.js'
const state = {
  pending: null,
  complete: null,
  taskDates: null,
  tasksByDate: null,
  tasks: null,
  installerTasks: null,
  installerComplete: null,
  stations: null,
  numComplete: 0
}
const mutations = {
  setTasks (state, payload) {
    state.tasks = payload
  },
  setStations (state, payload) {
    state.stations = payload
  },
  setPending (state, payload) {
    state.pending = payload
  },
  setTaskDates (state, payload) {
    state.taskDates = payload
  },
  setTasksByDates (state, payload) {
    state.tasksByDate = payload
  },
  setComplete (state, payload) {
    state.complete = payload
  },
  setInstallerComplete (state, payload) {
    state.installerComplete = payload
  },
  setInstallerTasks (state, payload) {
    state.installerTasks = payload
  },
  resetPendingState (state) {
    state.pending = null
  },
  resetCompleteState (state) {
    state.complete = []
  },
  resetStations (state) {
    state.stations = null
  },
  resetTasks (state) {
    state.tasks = null
  },
  removeTask (state, payload) {
    state.complete.push(payload.item)
    state.pending = state.pending.filter((i) => {
      return payload.item.serialCode !== i.serialCode
    })
  },
  removeComplete (state, payload) {
    state.pending.push(payload.item)
    state.complete = state.complete.filter((i) => {
      return payload.item.serialCode !== i.serialCode
    })
  }
}

const getters = {
  getPendingTasks (state) {
    return state.pending
  },
  getCompleteTasks (state) {
    return state.complete
  },
  getInstallerTasks (state) {
    return state.installerTasks
  },
  getInstallerComplete (state) {
    return state.installerComplete
  },
  getTaskDates (state) {
    return state.taskDates
  },
  getTasksByDates (state) {
    return state.tasksByDate
  },
  getStations (state) {
    return state.stations
  },
  getTasks (state) {
    return state.tasks
  }
}

const actions = {
  getTasks ({ commit }, payload) {
    $axios.get(payload.urlPending)
    .then(response => {
      commit('setPending', response.data)
      $axios.get(payload.urlComplete)
      .then(response => {
        commit('setComplete', response.data)
      })
    })
  },
  getInstallerData ({ commit }, payload) {
    $axios.get(payload.urlComplete)
    .then(response => {
      commit('setInstallerComplete', response.data)
      $axios.get(payload.urlPending)
      .then(response => {
        commit('setInstallerTasks', response.data)
      })
    })
  },
  getInstallerTasks ({ commit }, payload) {
    $axios.get(payload.urlPending)
    .then(response => {
      commit('setInstallerTasks', response.data)
    })
  },
  getInstallerComplete ({ commit }, payload) {
    commit('setInstallerComplete', payload)
  },
  completeTask ({ commit, dispatch }, payload) {
    $axios.post(payload.url, payload.obj)
    .then(response => {
      dispatch('fetchInstallersTasks', { url: payload.url2 })
    })
  },
  undoComplete ({ commit, dispatch }, payload) {
    $axios.post(payload.url, payload.obj)
    .then(response => {
      dispatch('fetchInstallersTasks', { url: payload.url2 })
    })
  },
  loadStations ({ commit }, payload) {
    $axios.get(payload.url)
    .then(response => {
      commit('resetTasks')
      commit('resetStations')
      commit('setStations', response.data)
    })
  },
  fetchInstallersTasks ({ commit }, payload) {
    $axios.get(payload.url)
    .then(response => {
      commit('resetTasks')
      commit('setTasks', response.data)
    })
  },
  resetTasks ({ commit }) {
    commit('resetTasks')
    commit('resetStations')
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/tasks.js